export default __webpack_public_path__ + "static/media/studio 9.51046249.png";